/**
 * Haversine distance between two lat/lng points in kilometers.
 * Returns null if any coordinate is missing.
 */
export function haversineKm(lat1, lon1, lat2, lon2) {
  if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) return null;
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Rank service persons by skill match + distance from a property.
 * Returns sorted array with distance and matchScore added.
 */
export function rankServicePersons(servicePeople, property, maintenanceDesc) {
  if (!servicePeople || servicePeople.length === 0) return [];
  const propLat = property?.latitude ? Number(property.latitude) : null;
  const propLng = property?.longitude ? Number(property.longitude) : null;
  const desc = (maintenanceDesc || "").toLowerCase();

  return servicePeople
    .filter(sp => sp.active)
    .map(sp => {
      const spLat = sp.latitude ? Number(sp.latitude) : null;
      const spLng = sp.longitude ? Number(sp.longitude) : null;
      const dist = haversineKm(propLat, propLng, spLat, spLng);
      const skill = (sp.skill || "").toLowerCase();

      // Skill match scoring
      let matchScore = 0;
      if (skill && desc) {
        const keywords = skill.split(/[,\s/]+/).filter(Boolean);
        const descWords = desc.split(/[,\s/]+/).filter(Boolean);
        if (keywords.some(k => desc.includes(k)) || descWords.some(w => skill.includes(w))) {
          matchScore = 2; // partial match
        }
        if (skill === desc || keywords.some(k => descWords.includes(k))) {
          matchScore = 3; // exact match
        }
      }
      if (skill === "general") matchScore = Math.max(matchScore, 1);

      return { ...sp, distance: dist, matchScore };
    })
    .sort((a, b) => {
      // Sort by: match score desc, then distance asc (nulls last)
      if (b.matchScore !== a.matchScore) return b.matchScore - a.matchScore;
      if (a.distance == null && b.distance == null) return 0;
      if (a.distance == null) return 1;
      if (b.distance == null) return -1;
      return a.distance - b.distance;
    });
}
